import Vue from "vue";

import { Trans } from "@/shared/scripts/helpers/translation/translation";

// Interfaces
import { InputMask } from "@/shared/interfaces/InputMask.interface";
import store from "@/shared/store/index";
import router from "./shared/router";

import { i18n } from "@/shared/scripts/helpers/translation/i18n";
import { VueDialog } from "./shared/interfaces/Dialog.interfaces";

// Get Input Mask

const BASE_OPTIONS: InputMask = {
    currency: "",
    currencyPosition: "suffix",
    precision: 0,
    separator: " ",
    min: 0,
    max: 999999999,
};

const LOCALE_OVERRIDES: Record<string, Partial<InputMask>> = {
    en: {
        currencyPosition: "prefix",
        separator: ".",
        thousandSeparator: ".",
    },
    nl: {
        currencyPosition: "prefix",
        separator: " ",
        thousandSeparator: " ",
    },
};

const FIELD_CONFIGS: Record<string, (locale: string) => InputMask> = {
    price: (locale) => ({
        ...BASE_OPTIONS,
        currency: "€",
        thousandSeparator: " ",
        ...LOCALE_OVERRIDES[locale],
    }),
    surface: (locale) => ({
        ...BASE_OPTIONS,
        currency: locale === "en" ? "sqm" : "m²",
        separator: locale === "en" ? "." : " ",
    }),
    length: (locale) => ({
        ...BASE_OPTIONS,
        currency: "m",
        separator: locale === "en" ? "." : " ",
    }),
    energy: (locale) => ({
        ...BASE_OPTIONS,
        currency: "kWh/m²",
        separator: locale === "en" ? "." : " ",
    }),
    year: () => ({
        ...BASE_OPTIONS,
        currency: "",
        separator: "",
        thousandSeparator: "",
        max: 9999,
    }),
    integer: (locale) => ({
        ...BASE_OPTIONS,
        currency: "",
        separator: locale === "en" ? "." : " ",
    }),
    epcSqm: (locale) => ({
        ...BASE_OPTIONS,
        currency: "",
        min: -999999999,
        separator: locale === "en" ? "." : " ",
    }),
};

Vue.prototype.getInputMask = (type?: string): InputMask => {
    const locale = Trans.currentLocale;
    const config = type ? FIELD_CONFIGS[type] : undefined;
    return config ? config(locale) : { ...BASE_OPTIONS };
};

// i18nRoute
Vue.prototype.$i18nRoute = Trans.i18nRoute.bind(Trans);

// Property Type
Vue.prototype.getPropertyType = () => {
    return store.getters["FormModule/getValue"]("property.type");
};

// Transaction Type
Vue.prototype.getTransactionType = () => {
    return store.getters["FormModule/getValue"]("transaction.type");
};

Vue.prototype.getErrorMessage = (pathInStore: string) => {
    if(store.getters["StepsWizard/getIndexVisited"] !== 0 && (store.getters["StepsWizard/getIndexVisited"] <= store.getters["StepsWizard/getCurrent"].index)) {
        return;
    }
    return store.getters["FormModule/getErrorObjectByPath"](pathInStore);
};

// Route to page

Vue.prototype.routeToPage = (stepname: string) => {
    let urlTranslated = i18n.t(stepname) as string;
    const classifiedId = router.currentRoute.params.id || store.getters["FormModule/getClassifiedId"];
    if (classifiedId) {
        if (stepname === "route-optimized-encoding") {
            urlTranslated = urlTranslated + "/" + classifiedId;
        } else {
            urlTranslated = urlTranslated + classifiedId;
        }
    }
    router.push(urlTranslated);
};


/**
 * [is Visible Check if an element is visible or not (Elements are considered visible if they consume space in the document. )]
 * @return {boolean} [Visible elements have a width or height that is greater than zero]
 */
Vue.prototype.isVisible = (element: HTMLElement) => {
    return element.offsetWidth > 0 && element.offsetHeight > 0;
};

Vue.prototype.pluralization = (key: string, data: number) => {
    return Trans.pluralization(key, data);
};

/**
 * Format a currency value in the given locale.
 */
Vue.prototype.formatCurrency = (value: string) => {
    return parseFloat(value).toLocaleString(
        Trans.currentLocale,
        {
            style: "currency",
            currency: "EUR",
            minimumFractionDigits: 0,
            maximumFractionDigits: 2
        }
    );
};

Vue.prototype.dialog = {
    alert: (message, options = {}) => store.dispatch("Dialog/alert", {
        ...{ okLabel: "OK" },
        ...options,
        message: message,
    }),

    confirm: (message, options = {}) => store.dispatch("Dialog/confirm", {
        ...{ cancelLabel: "Cancel", okLabel: "OK" },
        ...options,
        message: message,
    }),
} as VueDialog;
